module.exports = __webpack_public_path__ + "img/LINE_LOGO.37b0675d.png";